import React from 'react';
import { ImageIcon } from 'lucide-react';
interface PlaceholderMockupProps {
  label: string;
  aspect?: string;
  className?: string;
  src?: string;
  alt?: string;
  width?: number;
  height?: number;
}
export function PlaceholderMockup({
  label,
  aspect = 'aspect-[3/4]',
  className = '',
  src,
  alt,
  width = 800,
  height = 1000
}: PlaceholderMockupProps) {
  if (src) {
    return <div className={`relative w-full ${aspect} overflow-hidden rounded-2xl border border-mp-border bg-mp-dark ${className}`} data-id="element-336" data-mp="3udjly70am32">
        <img src={src} alt={alt || label} width={width} height={height} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-337" data-mp="8sx55xhotvuw" />
      </div>;
  }
  return <div className={`relative w-full ${aspect} overflow-hidden rounded-2xl border border-mp-border bg-gradient-to-br from-[#0B1117] to-[#10171D] ${className}`} data-id="element-338" data-mp="2fjwnavzhhjzr">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(circle at 28% 18%, rgba(8,117,209,0.35), transparent 62%)'
    }} data-id="element-339" data-mp="17md0ns0q887h" />
      <div className="absolute inset-0 opacity-40" style={{
      backgroundImage: 'linear-gradient(rgba(174,183,191,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(174,183,191,0.05) 1px, transparent 1px)',
      backgroundSize: '28px 28px'
    }} data-id="element-340" data-mp="12p2zxg7w0a4c" />
      <span className="absolute right-4 top-4 h-2 w-2 rounded-full bg-mp-lime" aria-hidden="true" data-id="element-341" data-mp="1qje7zjhr6kel" />
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center gap-3 px-6 text-center" data-id="element-342" data-mp="1lluitojion7v">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-mp-lime/40" data-id="element-343" data-mp="20cuyoemlfje1">
          <ImageIcon className="h-5 w-5 text-mp-lime" strokeWidth={1.75} data-id="element-344" data-mp="29botq0ka01ph" />
        </div>
        <span className="font-heading text-sm uppercase tracking-wide text-mp-white md:text-base" data-id="element-345" data-mp="299cazl6p1nbd">{label}</span>
        <span className="text-[10px] uppercase tracking-[0.2em] text-mp-gray" data-id="element-346" data-mp="2cdbcr0rqj7io">Imagen pendiente</span>
      </div>
    </div>;
}